import { item } from '../../utils/animations';
import styles from './FaqCard.module.css';
import { motion, AnimatePresence } from "framer-motion";
import { ReactComponent as ArrowDownSvg } from "../../../assets/icons/arrow-down.svg";
import { useState } from 'react';

export type FaqCardProps = {
    title: string;
    description: string;
}

export const FaqCard = ({ title, description }: FaqCardProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={styles.wrapper}>
            <motion.div
                className={styles.container}
                variants={item}
                onClick={() => setIsOpen(prev => !prev)}
            >
                <div className={styles.body}>
                    <h1 className={styles.title}>{title}</h1>

                    <motion.div
                        animate={{ rotate: isOpen ? 180 : 0 }}
                        transition={{ duration: 0.3, ease: "easeInOut" }}
                        style={{ display: "flex" }}
                    >
                        <ArrowDownSvg height={24} width={24} />
                    </motion.div>
                </div>

                <AnimatePresence initial={false}>
                    {isOpen && (
                        <motion.div
                            key="description"
                            initial={{ height: 0, opacity: 0 }}
                            animate={{ height: "auto", opacity: 1 }}
                            exit={{ height: 0, opacity: 0 }}
                            transition={{ duration: 0.35, ease: "easeInOut" }}
                            style={{ overflow: "hidden" }}
                        >
                            <p className={styles.description}>{description}</p>
                        </motion.div>
                    )}
                </AnimatePresence>
            </motion.div>
        </div>
    );
}